// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings-page {
  padding: 2rem;
  max-width: 1200px;
  margin: 0 auto;
}

.settings-container {
  display: grid;
  grid-template-columns: 250px 1fr;
  gap: 2rem;
  margin-top: 2rem;
}

.settings-tabs {
  background: var(--white);
  border-radius: 1rem;
  padding: 1rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
  height: fit-content;
}

.tab-button {
  width: 100%;
  padding: 1rem;
  background: transparent;
  border: none;
  border-radius: 0.5rem;
  display: flex;
  align-items: center;
  gap: 0.75rem;
  color: var(--medium-gray);
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  margin-bottom: 0.5rem;
}

.tab-button:hover {
  background: var(--light-gray);
  color: var(--dark-gray);
}

.tab-button.active {
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  color: var(--white);
}

.settings-content {
  background: var(--white);
  border-radius: 1rem;
  padding: 2rem;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);
}

.settings-section h2 {
  font-size: 1.75rem;
  color: var(--dark-gray);
  margin-bottom: 2rem;
}

.settings-form {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.notification-settings {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.toggle-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem;
  background: var(--background);
  border-radius: 0.5rem;
  transition: all 0.3s ease;
}

.toggle-item:hover {
  background: var(--light-gray);
}

.toggle-item h4 {
  font-size: 1.1rem;
  color: var(--dark-gray);
  margin-bottom: 0.25rem;
}

.toggle-item p {
  font-size: 0.875rem;
  color: var(--medium-gray);
}

.toggle-switch {
  position: relative;
  display: inline-block;
  width: 60px;
  height: 30px;
}

.toggle-switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

.toggle-slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: var(--light-gray);
  transition: 0.4s;
  border-radius: 30px;
}

.toggle-slider:before {
  position: absolute;
  content: "";
  height: 22px;
  width: 22px;
  left: 4px;
  bottom: 4px;
  background-color: white;
  transition: 0.4s;
  border-radius: 50%;
}

input:checked + .toggle-slider {
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
}

input:checked + .toggle-slider:before {
  transform: translateX(30px);
}

.appearance-settings {
  display: flex;
  flex-direction: column;
  gap: 2rem;
}

.setting-item h4 {
  font-size: 1.1rem;
  color: var(--dark-gray);
  margin-bottom: 1rem;
}

.theme-options {
  display: flex;
  gap: 1rem;
}

.theme-option {
  padding: 1rem 2rem;
  border: 2px solid var(--light-gray);
  border-radius: 0.5rem;
  background: var(--white);
  color: var(--dark-gray);
  font-size: 1rem;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.3s ease;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.theme-option:hover {
  border-color: var(--primary-blue);
}

.theme-option.active {
  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));
  color: var(--white);
  border-color: var(--primary-blue);
}

.color-options {
  display: flex;
  gap: 1rem;
}

.color-option {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  border: 3px solid transparent;
  cursor: pointer;
  transition: all 0.3s ease;
}

.color-option.active {
  border-color: var(--dark-gray);
  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);
}

.color-blue {
  background: linear-gradient(135deg, #3b82f6, #60a5fa);
}

.color-green {
  background: linear-gradient(135deg, #10b981, #34d399);
}

.color-purple {
  background: linear-gradient(135deg, #8b5cf6, #a78bfa);
}

.color-orange {
  background: linear-gradient(135deg, #f59e0b, #fbbf24);
}

.font-size-select {
  padding: 0.75rem;
  border: 2px solid var(--light-gray);
  border-radius: 0.5rem;
  background: var(--white);
  color: var(--dark-gray);
  font-size: 1rem;
  width: 200px;
  cursor: pointer;
}

.security-settings {
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.security-info {
  padding: 1.5rem;
  background: var(--background);
  border-radius: 0.5rem;
  margin-top: 1rem;
}

.security-info h4 {
  font-size: 1.1rem;
  color: var(--dark-gray);
  margin-bottom: 0.5rem;
}

.security-info p {
  color: var(--medium-gray);
  margin-bottom: 1rem;
}

.settings-actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 2rem;
  padding-top: 2rem;
  border-top: 1px solid var(--light-gray);
}

/* Sashe API Settings */
.sashe-settings {
  padding: 20px 0;
}

.shop-section {
  margin-bottom: 30px;
  padding: 20px;
  background: #f9fafb;
  border-radius: 8px;
}

.shop-section h3 {
  margin-bottom: 15px;
  color: #333;
  font-size: 1.2rem;
}

.api-actions {
  display: flex;
  gap: 10px;
  margin: 20px 0;
  flex-wrap: wrap;
}

.api-actions button {
  min-width: 150px;
}

.api-info {
  margin-top: 30px;
  padding: 20px;
  background: #e3f2fd;
  border-radius: 8px;
  border-left: 4px solid #2196f3;
}

.api-info h4 {
  margin-bottom: 10px;
  color: #1976d2;
}

.api-info ul {
  list-style: none;
  padding: 0;
}

.api-info li {
  padding: 5px 0;
  color: #555;
}

.api-info li:before {
  content: "→ ";
  color: #2196f3;
  font-weight: bold;
}

/* Sashe-klikáč produkty */
.sashe-products {
  margin-top: 20px;
}

.sashe-products .actions {
  margin-bottom: 20px;
}

.products-list h3 {
  margin: 20px 0 10px 0;
  color: #1976d2;
  border-bottom: 2px solid #e0e0e0;
  padding-bottom: 5px;
}

.product-items {
  display: flex;
  flex-direction: column;
  gap: 10px;
  margin-bottom: 30px;
}

.product-item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 8px;
  border-left: 4px solid #2196f3;
}

.product-item.completed {
  border-left-color: #4caf50;
  background: #f1f8e9;
}

.product-info {
  flex: 1 1;
  display: flex;
  flex-direction: column;
  gap: 5px;
}

.product-name {
  font-weight: bold;
  color: #333;
}

.product-order {
  font-size: 0.9em;
  color: #666;
}

.product-processed {
  font-size: 0.8em;
  color: #888;
  font-style: italic;
}

.product-status {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  margin: 0 15px;
}

.status, .result {
  padding: 4px 8px;
  border-radius: 4px;
  font-size: 0.8em;
  font-weight: bold;
  text-transform: uppercase;
}

.status.active {
  background: #2196f3;
  color: white;
}

.status.completed {
  background: #4caf50;
  color: white;
}

.result.success {
  background: #e8f5e8;
  color: #2e7d32;
}

.result.failed {
  background: #ffebee;
  color: #c62828;
}

.product-actions {
  min-width: 100px;
}`, "",{"version":3,"sources":["webpack://./src/pages/Settings.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,gCAAgC;EAChC,SAAS;EACT,gBAAgB;AAClB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,uBAAuB;EACvB,YAAY;EACZ,qBAAqB;EACrB,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,6BAA6B;EAC7B,uBAAuB;AACzB;;AAEA;EACE,+EAA+E;EAC/E,mBAAmB;AACrB;;AAEA;EACE,wBAAwB;EACxB,mBAAmB;EACnB,aAAa;EACb,0CAA0C;AAC5C;;AAEA;EACE,kBAAkB;EAClB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;EACV,QAAQ;EACR,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,mCAAmC;EACnC,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,SAAS;EACT,WAAW;EACX,uBAAuB;EACvB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,+EAA+E;AACjF;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,kBAAkB;EAClB,mCAAmC;EACnC,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,+EAA+E;EAC/E,mBAAmB;EACnB,iCAAiC;AACnC;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,6BAA6B;EAC7B,eAAe;EACf,yBAAyB;AAC3B;;AAEA;EACE,8BAA8B;EAC9B,wCAAwC;AAC1C;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,gBAAgB;EAChB,mCAAmC;EACnC,qBAAqB;EACrB,wBAAwB;EACxB,uBAAuB;EACvB,eAAe;EACf,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,6BAA6B;EAC7B,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,gBAAgB;EAChB,iBAAiB;EACjB,uCAAuC;AACzC;;AAEA,uBAAuB;AACvB;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,cAAc;EACd,WAAW;AACb;;AAEA;EACE,aAAa;EACb,cAAc;EACd,iBAAiB;AACnB;;AAEA,0BAA0B;AAC1B;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,gCAAgC;EAChC,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,aAAa;EACb,sBAAsB;EACtB,QAAQ;AACV;;AAEA;EACE,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;EAChB,iBAAiB;EACjB,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,gBAAgB;AAClB","sourcesContent":[".settings-page {\n  padding: 2rem;\n  max-width: 1200px;\n  margin: 0 auto;\n}\n\n.settings-container {\n  display: grid;\n  grid-template-columns: 250px 1fr;\n  gap: 2rem;\n  margin-top: 2rem;\n}\n\n.settings-tabs {\n  background: var(--white);\n  border-radius: 1rem;\n  padding: 1rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n  height: fit-content;\n}\n\n.tab-button {\n  width: 100%;\n  padding: 1rem;\n  background: transparent;\n  border: none;\n  border-radius: 0.5rem;\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  color: var(--medium-gray);\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  margin-bottom: 0.5rem;\n}\n\n.tab-button:hover {\n  background: var(--light-gray);\n  color: var(--dark-gray);\n}\n\n.tab-button.active {\n  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));\n  color: var(--white);\n}\n\n.settings-content {\n  background: var(--white);\n  border-radius: 1rem;\n  padding: 2rem;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.08);\n}\n\n.settings-section h2 {\n  font-size: 1.75rem;\n  color: var(--dark-gray);\n  margin-bottom: 2rem;\n}\n\n.settings-form {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.notification-settings {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.toggle-item {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 1.5rem;\n  background: var(--background);\n  border-radius: 0.5rem;\n  transition: all 0.3s ease;\n}\n\n.toggle-item:hover {\n  background: var(--light-gray);\n}\n\n.toggle-item h4 {\n  font-size: 1.1rem;\n  color: var(--dark-gray);\n  margin-bottom: 0.25rem;\n}\n\n.toggle-item p {\n  font-size: 0.875rem;\n  color: var(--medium-gray);\n}\n\n.toggle-switch {\n  position: relative;\n  display: inline-block;\n  width: 60px;\n  height: 30px;\n}\n\n.toggle-switch input {\n  opacity: 0;\n  width: 0;\n  height: 0;\n}\n\n.toggle-slider {\n  position: absolute;\n  cursor: pointer;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  background-color: var(--light-gray);\n  transition: 0.4s;\n  border-radius: 30px;\n}\n\n.toggle-slider:before {\n  position: absolute;\n  content: \"\";\n  height: 22px;\n  width: 22px;\n  left: 4px;\n  bottom: 4px;\n  background-color: white;\n  transition: 0.4s;\n  border-radius: 50%;\n}\n\ninput:checked + .toggle-slider {\n  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));\n}\n\ninput:checked + .toggle-slider:before {\n  transform: translateX(30px);\n}\n\n.appearance-settings {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n}\n\n.setting-item h4 {\n  font-size: 1.1rem;\n  color: var(--dark-gray);\n  margin-bottom: 1rem;\n}\n\n.theme-options {\n  display: flex;\n  gap: 1rem;\n}\n\n.theme-option {\n  padding: 1rem 2rem;\n  border: 2px solid var(--light-gray);\n  border-radius: 0.5rem;\n  background: var(--white);\n  color: var(--dark-gray);\n  font-size: 1rem;\n  font-weight: 500;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.theme-option:hover {\n  border-color: var(--primary-blue);\n}\n\n.theme-option.active {\n  background: linear-gradient(135deg, var(--primary-blue), var(--secondary-blue));\n  color: var(--white);\n  border-color: var(--primary-blue);\n}\n\n.color-options {\n  display: flex;\n  gap: 1rem;\n}\n\n.color-option {\n  width: 50px;\n  height: 50px;\n  border-radius: 50%;\n  border: 3px solid transparent;\n  cursor: pointer;\n  transition: all 0.3s ease;\n}\n\n.color-option.active {\n  border-color: var(--dark-gray);\n  box-shadow: 0 0 0 3px rgba(0, 0, 0, 0.1);\n}\n\n.color-blue {\n  background: linear-gradient(135deg, #3b82f6, #60a5fa);\n}\n\n.color-green {\n  background: linear-gradient(135deg, #10b981, #34d399);\n}\n\n.color-purple {\n  background: linear-gradient(135deg, #8b5cf6, #a78bfa);\n}\n\n.color-orange {\n  background: linear-gradient(135deg, #f59e0b, #fbbf24);\n}\n\n.font-size-select {\n  padding: 0.75rem;\n  border: 2px solid var(--light-gray);\n  border-radius: 0.5rem;\n  background: var(--white);\n  color: var(--dark-gray);\n  font-size: 1rem;\n  width: 200px;\n  cursor: pointer;\n}\n\n.security-settings {\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.security-info {\n  padding: 1.5rem;\n  background: var(--background);\n  border-radius: 0.5rem;\n  margin-top: 1rem;\n}\n\n.security-info h4 {\n  font-size: 1.1rem;\n  color: var(--dark-gray);\n  margin-bottom: 0.5rem;\n}\n\n.security-info p {\n  color: var(--medium-gray);\n  margin-bottom: 1rem;\n}\n\n.settings-actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-top: 2rem;\n  padding-top: 2rem;\n  border-top: 1px solid var(--light-gray);\n}\n\n/* Sashe API Settings */\n.sashe-settings {\n  padding: 20px 0;\n}\n\n.shop-section {\n  margin-bottom: 30px;\n  padding: 20px;\n  background: #f9fafb;\n  border-radius: 8px;\n}\n\n.shop-section h3 {\n  margin-bottom: 15px;\n  color: #333;\n  font-size: 1.2rem;\n}\n\n.api-actions {\n  display: flex;\n  gap: 10px;\n  margin: 20px 0;\n  flex-wrap: wrap;\n}\n\n.api-actions button {\n  min-width: 150px;\n}\n\n.api-info {\n  margin-top: 30px;\n  padding: 20px;\n  background: #e3f2fd;\n  border-radius: 8px;\n  border-left: 4px solid #2196f3;\n}\n\n.api-info h4 {\n  margin-bottom: 10px;\n  color: #1976d2;\n}\n\n.api-info ul {\n  list-style: none;\n  padding: 0;\n}\n\n.api-info li {\n  padding: 5px 0;\n  color: #555;\n}\n\n.api-info li:before {\n  content: \"→ \";\n  color: #2196f3;\n  font-weight: bold;\n}\n\n/* Sashe-klikáč produkty */\n.sashe-products {\n  margin-top: 20px;\n}\n\n.sashe-products .actions {\n  margin-bottom: 20px;\n}\n\n.products-list h3 {\n  margin: 20px 0 10px 0;\n  color: #1976d2;\n  border-bottom: 2px solid #e0e0e0;\n  padding-bottom: 5px;\n}\n\n.product-items {\n  display: flex;\n  flex-direction: column;\n  gap: 10px;\n  margin-bottom: 30px;\n}\n\n.product-item {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 15px;\n  background: #f8f9fa;\n  border-radius: 8px;\n  border-left: 4px solid #2196f3;\n}\n\n.product-item.completed {\n  border-left-color: #4caf50;\n  background: #f1f8e9;\n}\n\n.product-info {\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  gap: 5px;\n}\n\n.product-name {\n  font-weight: bold;\n  color: #333;\n}\n\n.product-order {\n  font-size: 0.9em;\n  color: #666;\n}\n\n.product-processed {\n  font-size: 0.8em;\n  color: #888;\n  font-style: italic;\n}\n\n.product-status {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 5px;\n  margin: 0 15px;\n}\n\n.status, .result {\n  padding: 4px 8px;\n  border-radius: 4px;\n  font-size: 0.8em;\n  font-weight: bold;\n  text-transform: uppercase;\n}\n\n.status.active {\n  background: #2196f3;\n  color: white;\n}\n\n.status.completed {\n  background: #4caf50;\n  color: white;\n}\n\n.result.success {\n  background: #e8f5e8;\n  color: #2e7d32;\n}\n\n.result.failed {\n  background: #ffebee;\n  color: #c62828;\n}\n\n.product-actions {\n  min-width: 100px;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
